import MlLayout from "@/components/MlLayout";
import Header from "@/components/Header";
import { getAllCollegeMajorCase ,ViewCaseCountAdd} from "@/api/views/caselibrary";

export default {
  components: {
    MlLayout,
    Header,
  },
  data() {
    return {

      tree: {
        loading: false,
        data: [],
        defaultProps: {
          children: "majors",
          label: "name",
        },
      },
      table: {
        cases: [], // 用于存储当前选中的学院或专业的案例列表
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 获取显示数据
    async getData() {
      this.tree.loading = true;
      try {
        const res = await getAllCollegeMajorCase();
        if (res.code === 1) {
          this.tree.data = res.data;
        } else {
          console.error("获取数据失败:", res.message);
        }
      } catch (error) {
        console.error("请求失败:", error);
      } finally {
        this.tree.loading = false;
      }
    },
    // 处理节点点击事件
    handleNodeClick(data) {
       // 如果 data.majors 存在，则从 majors 中提取 cases
        if (data.majors) {
          const cases = data.majors.flatMap((major) => major.cases || []);
          this.table.cases = cases;
        } 
        // 如果 data.majors 不存在，则直接获取 data.cases
        else {
          this.table.cases = data.cases || [];
        }
    },
    ViewCase(id =""){

      ViewCaseCountAdd({
        case_id: id,
      });

      // 获取当前域名
      const currentDomain = window.location.origin;
      // 拼接完整 URL
      const fullUrl = `${currentDomain}/#/CaseView?caseID=${id}`;

      window.open(fullUrl, '_blank');

    }
  },
};